import {h, Fragment} from "preact"
export default function QuickAdd({ product }) {
    const modalId = `QuickAdd-${product.productId}`;
    return (
      <div
        // style="display: none!important"
        dangerouslySetInnerHTML={{
          __html: `
            <quick-add-modal id="${modalId}" class="quick-add-modal">
                <div role="dialog" aria-label="Choose options for ${product?.name}" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">
                    <button id="ModalClose-${product?.productId}" type="button" class="quick-add-modal__toggle" aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
                        </svg>
                    </button>
                    <div id="QuickAddInfo-${product?.productId}" class="quick-add-modal__content-info"></div>
                </div>
                </quick-add-modal>
          `
        }}
      />
    );
  }
  